import { render, staticRenderFns } from "./Decoration.vue?vue&type=template&id=15a89ff8&scoped=true&"
import script from "./Decoration.vue?vue&type=script&lang=ts&"
export * from "./Decoration.vue?vue&type=script&lang=ts&"
import style0 from "./Decoration.vue?vue&type=style&index=0&id=15a89ff8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a89ff8",
  null
  
)

export default component.exports